import { Breakpoint } from 'store/slice/screen';

export const getSearchResultNumber = (breakpoint: Breakpoint) => {
    if (breakpoint.xl) {
        return 16;
    }
    if (breakpoint.l) {
        return 12;
    }
    if (breakpoint.m) {
        return 6;
    }
    return 5;
};

export const getPopularCarouselNumber = () => {
    return 12;
};
